import type { MessageKey } from "./ru"

export const kyMessages = {
  "common.loading": "Жүктөлүүдө...",
  "common.error": "Ката",
  "common.back": "Артка",
  "common.next": "Кийинки",
  "common.search": "Издөө",
  "auth.loginErrorTitle": "Кирүү катасы",
  "auth.openViaTelegram": "Колдонмону Telegram аркылуу ачыңыз",
  "auth.telegramRequired": "Колдонмо Telegram аркылуу ачылышы керек",
  "auth.authorizationError": "Авторизация катасы",
  "device.rotatePortrait": "Түзмөктү тик абалга буруңуз",
  "country.brazil": "Бразилия",
  "country.vietnam": "Вьетнам",
  "country.egypt": "Египет",
  "country.india": "Индия",
  "country.indonesia": "Индонезия",
  "country.iran": "Иран",
  "country.spain": "Испания",
  "country.italy": "Италия",
  "country.kazakhstan": "Казакстан",
  "country.colombia": "Колумбия",
  "country.malaysia": "Малайзия",
  "country.mexico": "Мексика",
  "country.nigeria": "Нигерия",
  "country.pakistan": "Пакистан",
  "country.russia": "Россия",
  "country.usa": "АКШ",
  "country.turkey": "Түркия",
  "country.uzbekistan": "Өзбекстан",
  "country.ukraine": "Украина",
  "country.philippines": "Филиппиндер",
  "countrySelection.chooseCountry": "Өлкөнү тандаңыз",
  "countrySelection.openAria": "Өлкөнү тандоо",
  "languageSelection.chooseLanguage": "Тилди тандаңыз",
  "commercial.direction.autotrade": "Авто базар",
  "commercial.direction.insurance": "Камсыздандыруу",
  "commercial.direction.pitstop": "Пит-стоп",
  "commercial.direction.techhelp": "Жолдо жардам",
  "commercial.searchLabel": "BeepApp издөөсү",
  "commercial.cityPlaceholder": "Шаарды киргизиңиз",
  "commercial.emptyTitle": "Бүгүн сунуштар жок",
  "commercial.emptyLine1": "Шаарыңызда азырынча активдүү BeepApp өнөктөштөрү жок",
  "commercial.emptyLine2": "Биз аларды издеп жана туташтыруу үстүндө иштеп жатабыз",
  "commercial.emptyLine3": "Жаңы сунуштар бул жерде автоматтык түрдө пайда болот",
  "commercial.helperLine1": "Жеткиликтүү сунуштарды көрүү үчүн",
  "commercial.helperLine2": "шаарыңызды киргизиңиз",
  "commercial.partnerPrompt": "BeepApp өнөктөшү болгуңуз келеби?",
  "commercial.apply": "Арыз берүү",
  "main.admin": "Админ",
  "main.garage": "Гараж",
  "main.signalSent": "Сигнал жөнөтүлдү",
  "main.partnerInviteUnavailable": "Өнөктөштүк чакыруу жеткиликсиз",
  "main.enterPlate": "Мамлекеттик номерди киргизиңиз",
  "main.searchError": "Издөө катасы",
  "main.signalSendError": "Сигнал жөнөтүлгөн жок",
  "main.shareCardPrefix": "Номер карточкасы",
  "main.shareLinkError": "Шилтемени даярдоо мүмкүн болгон жок",
  "main.searchByPlateAria": "Мамлекеттик номер боюнча издөө",
  "main.russianPlateAria": "Россиянын мамлекеттик номери",
  "main.plateAria": "Мамлекеттик номер",
  "main.findPlateAria": "Номерди табуу",
  "main.loadingVehicle": "Номер карточкасы жүктөлүүдө…",
  "main.leaveSignal": "Сигнал жөнөтүү",
  "main.share": "Бөлүшүү",
  "signalSelection.chooseType": "Сигналдын түрүн тандаңыз",
  "signalSelection.category.attention": "Жеке",
  "signalSelection.category.road": "Жол",
  "signalSelection.category.urgent": "Шашылыш",
  "signalSelection.chooseSignal": "Сигналды тандаңыз",
  "signalSelection.suggestOwn": "Өз вариантыңызды сунуштаңыз",
  "signalConfirmation.title": "Сигналды ырастаңыз",
  "signalConfirmation.plateHeading": "Мамлекеттик номерди текшериңиз",
  "signalConfirmation.signalHeading": "Тандалган сигналды текшериңиз",
  "signalConfirmation.replyTitle": "Telegram аркылуу жооп берүүгө уруксат берүү",
  "signalConfirmation.replyBody": "Муну күйгүзсөңүз, номердин ээси сизге\nTelegram аркылуу жаза алат. Жооп берүү сизде\n@username болгондо гана мүмкүн. Жооп берүү чечими\nномердин ээсинде калат.",
  "signalConfirmation.consentText": "Бул сигнал чыныгы кырдаалды\nчагылдырарын жана спам же\nжалган билдирүү эмес экенин ырастайм.",
  "signalConfirmation.warning": "Жөнөткөндөн кийин сигналды\nөзгөртүү мүмкүн эмес",
  "signalConfirmation.sending": "Жөнөтүлүүдө…",
  "signalConfirmation.send": "Жөнөтүү",
  "partner.loadingAria": "Жүктөлүүдө",
  "partner.title": "Өнөктөштүк программа",
  "partner.offerLine1": "Бардык төлөмдөрдөн мөөнөтсүз 30% алыңыз",
  "partner.offerLine2": "BeepApp'ка сиз чакырган колдонуучулардан",
  "partner.offerLine3": "Telegram өнөктөштүк программасы аркылуу",
  "partner.connectUnavailable": "Туташуу Telegram Affiliate Program жөндөлгөндөн кийин жеткиликтүү болот.",
  "partner.connectTelegram": "Telegram'да туташтыруу",
  "partner.qrAria": "Өнөктөштүк шилтеменин QR-коду",
  "partner.download": "Жүктөп алуу",
  "partner.promoHeading": "Жеке промокод түзүңүз",
  "partner.promoHelperLine1": "Промокод кошумча бир жылдык жазылууну активдештирет",
  "partner.promoHelperLine2": "жана колдонуучуларды тартууга жардам берет",
  "partner.promoAria": "Промокод",
  "partner.affiliateHeading": "Сиздин өнөктөштүк шилтемеңиз",
  "partner.affiliateHelper": "Жеке QR-код түзүү үчүн шилтемени сактаңыз",
  "partner.affiliateAria": "Өнөктөштүк шилтеме",
  "partner.qrNoteLine1": "QR-кодду унааңызга,",
  "partner.qrNoteLine2": "социалдык тармактарга жана жарнамалык материалдарга жайгаштырса болот",
  "partner.save": "Сактоо",
  "partner.reset": "Баштапкы абалга келтирүү",
  "partner.resetConfirm": "Сакталган өнөктөштүк шилтемени өчүрөсүзбү? Промокод сизде калат.",
  "partner.promoFormatError": "Промокод 4төн 15ке чейин белгиден турушу керек.",
  "partner.affiliateHostError": "t.me же telegram.me шилтемелерине гана уруксат берилет.",
  "partner.affiliatePathError": "Шилтемеде Telegram жолу жок.",
  "partner.affiliateFormatError": "Өнөктөштүк шилтеме туура эмес.",
  "partner.loadError": "Жүктөө катасы",
  "partner.checkInputError": "Киргизилген маалыматты текшериңиз",
  "garageActivation.promoInvalid": "Промокод жараксыз",
  "garageActivation.plateOccupied": "Бул мамлекеттик номер буга чейин байланышкан",
  "garageActivation.activateError": "Гаражды активдештирүү мүмкүн болгон жок",
  "garageEntry.loadJournalError": "Борт журналын жүктөө мүмкүн болгон жок",
  "garageEntry.loadStatusesError": "Статустарды жүктөө мүмкүн болгон жок",
  "garageEntry.activationSuccess": "Гараж ийгиликтүү активдештирилди",
  "garageEntry.plateAttached": "Номер байланыштырылды",
  "garageEntry.attachError": "Номерди байланыштыруу мүмкүн болгон жок",
  "garageEntry.activationNote": "Гаражыңызды активдештириңиз",
  "garageSheet.activationTitle": "Гаражды активдештирүү",
  "garageSheet.plateHelper": "Унаанын мамлекеттик номерин киргизиңиз",
  "garageSheet.promoHelper": "Промокодуңуз барбы?",
  "garageSheet.cleanBonusLine1": "Активдештиргенден кийин 1 саатыңыз болот",
  "garageSheet.cleanBonusLine2": "акысыз «Таза старт» үчүн",
  "garageSheet.activationFor": "Активдештирүү мөөнөтү",
  "garageSheet.cost": "Баасы",
  "garageSheet.ownerConsentLine1": "Көрсөтүлгөн мамлекеттик номери бар",
  "garageSheet.ownerConsentLine2": "унаанын ээси экенимди",
  "garageSheet.ownerConsentLine3": "ырастайм.",
  "garageSheet.processing": "Иштелүүдө...",
  "garageSheet.attach": "Байлоо",
  "garageSheet.pay": "Төлөө",
  "garageLifecycle.cleanTitle": "Таза старт",
  "garageLifecycle.deactivateTitle": "Гаражды деактивдештирүү",
  "garageLifecycle.cleanWarningLine1": "Номердин тарыхы өчүрүлөт",
  "garageLifecycle.cleanWarningLine2": "кайра калыбына келтирүү мүмкүнчүлүгү жок!",
  "garageLifecycle.deactivateWarningLine1": "Деактивдештиргенден кийин активдүү",
  "garageLifecycle.deactivateWarningLine2": "Гараж функцияларына жетүү токтойт",
  "garageLifecycle.willBeDeleted": "ӨЧҮРҮЛӨТ",
  "garageLifecycle.cleanRemovedLine1": "• Борт журналындагы бардык жазуулар",
  "garageLifecycle.cleanRemovedLine2": "• Алынган сигналдардын тарыхы",
  "garageLifecycle.cleanRemovedLine3": "• Сигналдардын ачык эсептегичтери",
  "garageLifecycle.cleanRemovedLine4": "  номер карточкасында",
  "garageLifecycle.willRemain": "КАЛАТ",
  "garageLifecycle.cleanPreservedLine1": "• Номердин Гаражга байланышы",
  "garageLifecycle.cleanPreservedLine2": "• Активдештирүүнүн калган мөөнөтү",
  "garageLifecycle.cleanPreservedLine3": "• Тандалган номер статусу",
  "garageLifecycle.cleanPreservedLine4": "• Номер карточкасынын жалпы көрүүлөрү",
  "garageLifecycle.freeFirstHour": "Биринчи саатта акысыз",
  "garageLifecycle.willBecomeUnavailable": "ЖЕТКИЛИКСИЗ БОЛОТ",
  "garageLifecycle.deactivateRemovedLine1": "• Борт журналы",
  "garageLifecycle.deactivateRemovedLine2": "• Номер статусун тандоо жана колдонуу",
  "garageLifecycle.deactivateRemovedLine3": "• AutoClan'дан автоматтык түрдө чыгасыз",
  "garageLifecycle.deactivateRemovedLine4": "• Авто базар",
  "garageLifecycle.deactivateRemovedLine5": "• Камсыздандыруу",
  "garageLifecycle.deactivateRemovedLine6": "• Пит-стоп",
  "garageLifecycle.deactivateRemovedLine7": "• Жолдо жардам",
  "garageLifecycle.deactivateRemovedLine8": "• Мамлекеттик номер Гараждан ажыратылат",
  "garageLifecycle.willRemainAvailable": "ЖЕТКИЛИКТҮҮ БОЙДОН КАЛАТ",
  "garageLifecycle.deactivatePreservedLine1": "• Жолдош",
  "garageLifecycle.deactivatePreservedLine2": "• Диспетчер",
  "garageLifecycle.deactivatePreservedLine3": "• Мамлекеттик номерди издөө жана",
  "garageLifecycle.deactivatePreservedLine4": "  ачык унаа карточкасын көрүү",
  "garageLifecycle.deactivatePreservedLine5": "• Каалаган убакта Гаражды",
  "garageLifecycle.deactivatePreservedLine6": "  кайра активдештирүү мүмкүнчүлүгү",
  "garageLifecycle.cleanConsentLine1": "Бул номердин бардык тарыхын",
  "garageLifecycle.cleanConsentLine2": "кайра калыбына келтирүү мүмкүнчүлүгү жок",
  "garageLifecycle.cleanConsentLine3": "өчүрүүгө макул экенимди ырастайм.",
  "garageLifecycle.deactivateConsentLine1": "Деактивдештирүүнү жана бардык",
  "garageLifecycle.deactivateConsentLine2": "активдүү Гараж функцияларына",
  "garageLifecycle.deactivateConsentLine3": "жетүүнү токтотууну ырастайм.",
  "garageLifecycle.clean": "Тазалоо",
  "garageLifecycle.deactivate": "Деактивдештирүү",
} satisfies Record<MessageKey, string>
